// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__117mo","title":"Banner_title__2OG8i","banner":"Banner_banner__AWx4E","imgWrapper":"Banner_imgWrapper__1itIR","bannerImg":"Banner_bannerImg__3Dtpm"};